// @flow

import React from 'react';
import { isMobile } from 'react-device-detect';

import { body } from 'core/config';
import { jobs as t } from 'helpers/translation';
import BtnRounded from 'components/BtnRounded';

import JobAlert from './JobAlert';
import SavedSearches from './SavedSearches';

type Props = {
  showAlerts: boolean,
  search: any,
  toggleVisibility: Function,
  showInput: boolean,
  user: any,
  addJobAlert: Function,
  errors: any,
  updateSearch: Function
};

export default ({ showAlerts, search, toggleVisibility, showInput, user, addJobAlert, errors, updateSearch }: Props) => {
  const jobAlerts = user && user.jobAlerts;

  const handleClick = (item) => {
    body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';

    toggleVisibility(item);
  };

  const renderDesktop = () => (
    <div className={`jobs-alert__wrapper${showAlerts ? ' active' : ''}`}>
      <JobAlert
        toggleVisibility={toggleVisibility}
        search={search}
        showInput={showInput}
        userId={user && user.id}
        addJobAlert={addJobAlert}
        jobAlertErrors={errors}
      />
      {jobAlerts && <SavedSearches
        jobAlerts={jobAlerts}
        search={search}
        updateSearch={updateSearch}
        toggleVisibility={toggleVisibility}
      />}
    </div>
  );

  const renderMobile = () => (
    <div className={`mobile-filter__wrapper${showAlerts ? ' active-mobile' : ''}`}>
      <div className="mobile-filter">
        <div className="mobile-filter__buttons right">
          <BtnRounded
            iconBefore={showAlerts ? 'saved-search' : 'save-search'}
            text={t.btn.job_alert}
            classes={`btn_shadow jobs-filter__save-search${showAlerts ? ' active' : ''}`}
            handleClick={() => handleClick('alerts')}
          />
        </div>
        <div className="mobile-filter__inner">
          <JobAlert
            toggleVisibility={toggleVisibility}
            search={search}
            showInput={showInput}
            userId={user && user.id}
            addJobAlert={addJobAlert}
            jobAlertErrors={errors}
          />
          {jobAlerts && <SavedSearches
            jobAlerts={jobAlerts}
            search={search}
            updateSearch={updateSearch}
            toggleVisibility={toggleVisibility}
          />}
        </div>
      </div>
    </div>
  );

  return isMobile ? renderMobile() : renderDesktop();
};
